import React, { useEffect, useContext } from 'react'
import { AppContext } from '../..'
import { useHistory } from 'react-router-dom'

function Default() {
  const { state } = useContext(AppContext)
  const partners = state.auth.partners
  const history = useHistory()
  const selectedPartnerId = partners && partners.length > 0
    ? partners[0].id
    : null

  useEffect(() => {
    if (selectedPartnerId) {
      history.push(`/partner/${selectedPartnerId}`)
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedPartnerId])

  return (
    <div />
  )
}

export default Default